import { createConfirmation } from "react-confirm";
import CustomCNCPDFPreviewModal from "./CustomCNCPDFPreviewModal";

export const showCustomCNCPDPreviewModal = createConfirmation(CustomCNCPDFPreviewModal);